import { render } from "./Registration.vue?vue&type=template&id=468ddc6e&scoped=true"
import script from "./Registration.vue?vue&type=script&lang=js"
export * from "./Registration.vue?vue&type=script&lang=js"

import "./Registration.vue?vue&type=style&index=0&id=468ddc6e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-468ddc6e"

export default script